import { useCallback, useState } from 'react';

import { ConstructorApi } from '../api';
import { usePopups } from '@/hooks';

export const useRelatedQuestionnaire = () => {
  const { showErrorToast, showSuccessToast } = usePopups();
  const [isCreating, setIsCreating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleGet = useCallback(async (questionSectionTypeId) => {
    try {
      setIsCreating(true);
      return await ConstructorApi.getRelatedQuestionnaire({
        questionSectionTypeId: questionSectionTypeId
      });
    } catch (e) {
      showErrorToast(e, true);
    }
  }, []);

  const handleCreate = useCallback(
    async (questionSectionTypeId, groupId, conditions, questions) => {
      try {
        setIsCreating(true);
        const result = await ConstructorApi.createRelatedQuestionnaire(
          questionSectionTypeId,
          groupId,
          conditions,
          questions
        );
        if (result) showSuccessToast('Created');
      } catch (e) {
        showErrorToast(e, true);
      } finally {
        setIsCreating(false);
      }
    },
    []
  );

  const handleDelete = useCallback(async (relatedQuestionnaireId) => {
    try {
      setIsDeleting(true);
      const result = await ConstructorApi.deleteRelatedQuestionnaire(relatedQuestionnaireId);
      if (result) showSuccessToast('Saved');
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsDeleting(false);
    }
  }, []);

  return {
    handleGet,
    handleCreate,
    handleDelete,
    isCreating,
    isDeleting
  };
};
